import React from 'react';
import BackButton from '../buttons/BackButton';
import StatusIndicator from '../ui/StatusIndicator';

const PageHeader = ({ title, showBackButton = true, showStatus = false, rightContent = null, onBack = null }) => {
  return (
    <div className="w-full bg-white border-b border-gray-200 shadow-sm shrink-0">
      <div className="px-4 py-3 flex justify-between items-center h-14">
        <div className="flex items-center gap-3 overflow-hidden">
          {showBackButton && <BackButton onBack={onBack} />}
          <h2 className="text-gray-dark font-bold text-lg truncate">{title}</h2>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          {showStatus && <StatusIndicator />}
          {rightContent}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;